interface AuraState {
  fillStep: number
  baseGlow: number
  orbitingDots: Array<{
    id: string
    size: number
    distance: number
    duration: number
    direction: number
  }>
}

const STORAGE_KEY = 'aura-points-state'

export function useAuraPointsManager() {
  // Load initial state from localStorage
  const loadState = (): AuraState => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY)
      if (stored) {
        return JSON.parse(stored)
      }
    } catch (e) {
      console.error('Failed to load aura state:', e)
    }
    return {
      fillStep: 0,
      baseGlow: 0,
      orbitingDots: [],
    }
  }

  // Save state to localStorage
  const saveState = (state: AuraState) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state))
    } catch (e) {
      console.error('Failed to save aura state:', e)
    }
  }

  return {
    loadState,
    saveState,
  }
}
